import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { AuthLayout, AuthDivider, GoogleButton, PasswordField, inputClass } from "@/components/AuthLayout";
import { saveProfile } from "@/data/practiceData";
import { apiFetch, setToken } from "@/api";

const EMAIL_RE = /^\S+@\S+\.\S+$/;

const Signup = () => {
  const navigate = useNavigate();
  const [form, setForm] = useState({ name: "", email: "", password: "" });
  const [errors, setErrors] = useState({});

  const set = (key) => (e) =>
    setForm((f) => ({ ...f, [key]: e.target.value }));

  const handleSubmit = async (e) => {
    e.preventDefault();
    const errs = {};
    const email = form.email.trim();
    if (!form.name.trim()) errs.name = "Please enter your full name";
    if (!email) {
      errs.email = "Enter your email address";
    } else if (!EMAIL_RE.test(email)) {
      errs.email = "Enter a valid email address";
    }
    if (form.password.length < 6)
      errs.password = "Password must be at least 6 characters";
    setErrors(errs);
    if (Object.keys(errs).length > 0) return;
    try {
      const data = await apiFetch("/signup", {
        method: "POST",
        body: { name: form.name.trim(), email, password: form.password },
      });
      setToken(data.token);
      saveProfile({ name: data.user.name });
      navigate("/onboarding");
    } catch (err) {
      setErrors({ email: err.message });
    }
  };

  return (
    <AuthLayout
      title="Create your account"
      subtitle="Start practicing smarter in under a minute."
      footer={
        <>
          Already have an account?{" "}
          <Link
            to="/login"
            data-testid="goto-login-link"
            className="font-bold text-[#16A34A] hover:underline"
          >
            Log in
          </Link>
        </>
      }
    >
      <form data-testid="signup-form" onSubmit={handleSubmit} className="space-y-4" noValidate>
        <div>
          <label className="mb-1.5 block text-sm font-bold text-[#17201A]">
            Full name
          </label>
          <input
            data-testid="signup-name-input"
            type="text"
            value={form.name}
            onChange={set("name")}
            placeholder="Aarav Sharma"
            className={inputClass}
          />
          {errors.name && (
            <p data-testid="signup-name-input-error" className="mt-1.5 text-xs font-semibold text-red-500">
              {errors.name}
            </p>
          )}
        </div>
        <div>
          <label className="mb-1.5 block text-sm font-bold text-[#17201A]">
            Email
          </label>
          <input
            data-testid="signup-email-input"
            type="email"
            value={form.email}
            onChange={set("email")}
            placeholder="you@example.com"
            className={inputClass}
          />
          {errors.email && (
            <p data-testid="signup-email-error" className="mt-1.5 text-xs font-semibold text-red-500">
              {errors.email}
            </p>
          )}
        </div>
        <PasswordField
          label="Password"
          testid="signup-password-input"
          value={form.password}
          onChange={set("password")}
          placeholder="At least 6 characters"
          error={errors.password}
        />
        <button
          type="submit"
          data-testid="signup-submit-btn"
          data-magnetic="true"
          className="w-full rounded-full bg-[#16A34A] py-4 text-base font-bold text-white shadow-sm transition-[background-color,transform] duration-200 hover:bg-[#15803D]"
        >
          Create Account
        </button>
        <AuthDivider />
        <GoogleButton />
      </form>
    </AuthLayout>
  );
};

export default Signup;
